exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.save-btn-top{position:relative;top:-65px\n}\n.spacer{clear:both\n}", ""]);

// exports
